import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "../../../components/Common/Breadcrumb"; // Import Breadcrumbs component
import {
  changePasswordRequest,
} from "store/actions";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const ChangePassword = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Please enter your old password"),
      newPassword: Yup.string()
        .required("Please enter a new password")
        .min(8, "Password must be at least 8 characters long")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(/[@$!%*?&]/, "Password must contain at least one special character (@$!%*?&)"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
        .required("Please confirm your new password"),
    }),
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("Empid", authDetails?.empid);
      formData.append("oldpassword", values.oldPassword);
      formData.append("newpassword", values.newPassword);
      formData.append("condirmpassword", values.confirmPassword);
      formData.append("create_by", authDetails?.user_id);
      dispatch(changePasswordRequest(formData));
      formik.resetForm();
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumbs */}
          <Breadcrumbs title="Configuration" breadcrumbItem="Change Password" />

          {/* Card Section */}
          <Card>
            <CardBody>
              {/* <h5 className="mb-4">Change Password</h5> */}
              {/* Form */}
              <Form onSubmit={formik.handleSubmit} autoComplete="off">
                {/* Hidden inputs to prevent autofill */}
                <input
                  type="text"
                  name="fakeusername"
                  style={{ display: "none" }}
                  autoComplete="username"
                />
                <input
                  type="password"
                  name="fakepassword"
                  style={{ display: "none" }}
                  autoComplete="new-password"
                />

                <Row className="mb-3 g-md-2 g-lg-2 g-xl-3 ">
                  <Col md="4">
                    <FormGroup>
                      <Label for="oldPassword">
                        Old Password <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="oldPassword"
                        name="oldPassword"
                        type="password"
                        value={formik.values.oldPassword}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.oldPassword &&
                          Boolean(formik.errors.oldPassword)
                        }
                        autoComplete="new-password" // Prevent browser autofill
                      />
                      {formik.touched.oldPassword &&
                        formik.errors.oldPassword && (
                          <div className="text-danger">
                            {formik.errors.oldPassword}
                          </div>
                        )}
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    <FormGroup>
                      <Label for="newPassword">
                        New Password <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="newPassword"
                        name="newPassword"
                        type="password"
                        value={formik.values.newPassword}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.newPassword &&
                          Boolean(formik.errors.newPassword)
                        }
                        autoComplete="new-password"
                      />
                      {formik.touched.newPassword &&
                        formik.errors.newPassword && (
                          <div className="text-danger">
                            {formik.errors.newPassword}
                          </div>
                        )}
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    <FormGroup>
                      <Label for="confirmPassword">
                        Confirm Password <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="confirmPassword"
                        name="confirmPassword"
                        type="password"
                        value={formik.values.confirmPassword}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.confirmPassword &&
                          Boolean(formik.errors.confirmPassword)
                        }
                        autoComplete="new-password"
                      />
                      {formik.touched.confirmPassword &&
                        formik.errors.confirmPassword && (
                          <div className="text-danger">
                            {formik.errors.confirmPassword}
                          </div>
                        )}
                    </FormGroup>
                  </Col>
                </Row>
                {canEdit && (
                  <Row>
                    <Col className="d-flex justify-content-start">
                      <Button type="submit" className="btn button-save me-2">
                        <i className="fas fa-save me-1" /> Update
                      </Button>
                      <Button type="reset" className="btn button-cancel " onClick={formik.handleReset}>
                        <i className="fas fa-sync me-1" /> Cancel
                      </Button>
                    </Col>
                  </Row>
                )}
                
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ChangePassword;